import { i18n } from '@/plugins/i18n'

export const transactionsTypes = [
    // {
    //     name: i18n.t('label.transaction_type'),
    //     value: null,
    //     disable: true
    // },
    {
        name: i18n.t('transaction.types.api'),
        value: 'zero',
        disable: false
    },
    // {
    //     name: i18n.t('transaction.types.face'),
    //     value: 1,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.ivr'),
    //     value: 5,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.dedicated'),
    //     value: 10,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.collective_dedicated'),
    //     value: 14,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.collective_payment_helper'),
    //     value: 16,
    //     disable: false
    // },
    {
        name: i18n.t('transaction.types.sms_wallet_recharge'),
        value: 18,
        disable: false
    },
    // {
    //     name: i18n.t('transaction.types.money_request'),
    //     value: 21,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.card_to_card'),
    //     value: 22,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.wallet_recharge'),
    //     value: 26,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.money_request_bill'),
    //     value: 30,
    //     disable: false
    // },
    {
        name: i18n.t('transaction.types.online_factor'),
        value: 32,
        disable: false
    },
    // {
    //     name: i18n.t('transaction.types.ivr_wallet_recharge'),
    //     value: 33,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.collective_to_wallet'),
    //     value: 34,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.vip'),
    //     value: 35,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.vip_wallet_recharge'),
    //     value: 36,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.collective_to_wallet_money_request'),
    //     value: 37,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.collective_to_wallet_pardakht_shakhsi'),
    //     value: 38,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.collective_to_wallet_online_factor'),
    //     value: 39,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.money_request_bill_to_wallet'),
    //     value: 40,
    //     disable: false
    // },
    {
        name: i18n.t('transaction.types.enamad_register'),
        value: 41,
        disable: false
    },
    // {
    //     name: i18n.t('transaction.types.collection_on_payment_helper_to_wallet'),
    //     value: 47,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.collection_on_payment_helper_to_wallet_money_request'),
    //     value: 48,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.collection_on_payment_helper_to_wallet_pardakht_shakhsi'),
    //     value: 49,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.collection_on_payment_helper_to_wallet_online_factor'),
    //     value: 50,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.deposit_with_id'),
    //     value: 51,
    //     disable: false
    // },
    {
        name: i18n.t('transaction.types.payment_helper_psp_settlement'),
        value: 52,
        disable: false
    },
    // {
    //     name: i18n.t('transaction.types.payment_helper_psp_settlement_pardakht_shakhsi'),
    //     value: 53,
    //     disable: false
    // },
    {
        name: i18n.t('transaction.types.payment_helper_psp_settlement_online_factor'),
        value: 54,
        disable: false
    },
    // {
    //     name: i18n.t('transaction.types.payment_helper_psp_settlement_money_request'),
    //     value: 55,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.card_to_card_recharge_credit'),
    //     value: 56,
    //     disable: false
    // },
    // {
    //     name: i18n.t('transaction.types.card_to_card_wallet_recharge'),
    //     value: 57,
    //     disable: false
    // },
    {
        name: i18n.t('transaction.types.online_contract_price'),
        value: 58,
        disable: false
    },
    {
        name: i18n.t('transaction.types.refund'),
        value: 60,
        disable: false
    }
]